// VisiGiftUpdates.jsx

import React from "react";

const updates = [
  {
    dateTime: "2025-11-05T14:30",
    title: "VisiGift Points Redemption Goes Live",
    desc: "Users can now redeem earned points directly for exclusive discounts on Think5Whys shopping platform, starting with 100 points = ₹10 off."
  },
  {
    dateTime: "2025-10-28T11:00",
    title: "Integration with Think5Whys E-Store",
    desc: "Seamless point transfer to shopping cart – earn from ads, spend on gadgets, books, and more in one ecosystem."
  },
  {
    dateTime: "2025-10-20T09:45",
    title: "Daily Landing Bonus Enhanced",
    desc: "New streak rewards: Land on VisiGift home daily for up to 50 bonus points, encouraging consistent engagement."
  },
  {
    dateTime: "2025-10-15T17:15",
    title: "Button Click Challenges Launched",
    desc: "Click through 5 unique buttons daily to unlock mystery multipliers on your points collection."
  },
  {
    dateTime: "2025-10-10T13:30",
    title: "Partnership with Local Brands",
    desc: "Tie-up with RoomAnywhere and other partners – watch targeted ads for double points on home decor redemptions."
  },
  {
    dateTime: "2025-10-05T10:00",
    title: "VisiGift User Milestone: 10K Active Earners",
    desc: "Celebrating 10,000 users who have earned over 1M points collectively – special 20% redemption boost this week."
  },
  {
    dateTime: "2025-09-25T16:00",
    title: "Video Ad Rewards Tier Updated",
    desc: "Premium videos now offer up to 25 points per view, with progress tracking for binge-watch bonuses."
  },
  {
    dateTime: "2025-09-18T12:00",
    title: "Referral Program Activated",
    desc: "Invite friends to VisiGift and earn 100 starter points per successful referral, redeemable on Think5Whys."
  },
  {
    dateTime: "2025-09-10T18:30",
    title: "UI Refresh for Better Engagement",
    desc: "Sleek purple-themed dashboard with real-time point counters and one-tap button navigation."
  },
  {
    dateTime: "2025-09-01T15:00",
    title: "VisiGift Beta Launch",
    desc: "Official rollout of the rewarding ads module – start earning points today by simply landing and clicking!"
  }
];

const VisiGiftUpdates = () => {
  return (
    <section className="py-16 px-6 md:px-20 bg-gray-6000 min-h-screen">
      <h2 className="text-2xl font-bold text-center mb-12 text-yellow-200">VisiGift Updates</h2>
      <div className="space-y-6">
        {updates.map((update, idx) => (
          <div key={idx} className="bg-gray-600 rounded-lg shadow-md p-5 hover:shadow-lg transition">
            <div className="text-sm text-white mb-1">
              {new Date(update.dateTime).toLocaleString('en-IN', {
                dateStyle: 'medium',
                timeStyle: 'short'
              })}
            </div>
            <h3 className="text-lg font-semibold text-yellow-200">{update.title}</h3>
            <p className="text-white mt-1">{update.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VisiGiftUpdates;
